<template>
  <div id="redirect"></div>
</template>

<script>
import { Hub } from 'aws-amplify';
import { mapActions, mapState } from 'vuex';

export default {
  methods: {
    ...mapActions(['getLoginState']),
    async onHubCapsule({ channel, payload }) {
      if (channel === 'auth' && payload.event === 'cognitoHostedUI') {
        await this.getLoginState();
        window.location.reload();
      }
    }
  },
  computed: {
    ...mapState(['loggedIn'])
  },
  watch: {
    loggedIn() {
      this.$router.push({ path: '/' });
    }
  },
  async mounted() {
    Hub.listen('auth', this);
    if (this.$route.query) {
      if (this.$route.query.error) {
        this.$router.push('/');
      }
    }
  }
};
</script>
